import React from "react";

export default function TicketIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
    >
      <g clip-path="url(#clip0_627_23)">
        <path
          d="M10.4627 5.76436L7.37592 6.61815H7.40465V13.8712H5.89411V7.02452L4.13317 7.51298C4.10444 7.52119 4.07571 7.52529 4.04697 7.52529C3.90331 7.52529 3.77196 7.43088 3.73501 7.28722C3.68576 7.11482 3.78837 6.93421 3.96077 6.88495L10.2903 5.13223C10.4627 5.08297 10.6433 5.18559 10.6925 5.35799C10.7418 5.53039 10.6392 5.711 10.4668 5.76026L10.4627 5.76436Z"
          fill="black"
        />
        <path
          d="M8.61597 5.92033C8.41073 5.40313 8.11519 4.93519 7.73345 4.52882C7.29834 4.06499 6.75241 3.69556 6.15723 3.46159L6.31731 3.05933C6.97407 3.31792 7.57336 3.72429 8.04951 4.23328C8.46819 4.67659 8.79247 5.19379 9.01823 5.76435L8.61597 5.92443V5.92033Z"
          fill="black"
        />
        <path
          d="M6.09879 2.71879L5.14805 2.35498C4.90879 2.26343 4.64095 2.3823 4.54981 2.62049C4.45866 2.85869 4.57872 3.126 4.81797 3.21755L5.76871 3.58136C6.00797 3.67292 6.27581 3.55404 6.36695 3.31585C6.4581 3.07766 6.33804 2.81035 6.09879 2.71879Z"
          fill="black"
        />
        <path
          d="M1.95414 2.67342C2.67958 2.67342 3.26766 2.08534 3.26766 1.3599C3.26766 0.634468 2.67958 0.0463867 1.95414 0.0463867C1.22871 0.0463867 0.640625 0.634468 0.640625 1.3599C0.640625 2.08534 1.22871 2.67342 1.95414 2.67342Z"
          fill="black"
        />
        <path
          d="M0.488818 3.68314C0.52576 3.63799 0.964967 3.15363 1.5971 3.129C2.17586 3.10437 2.71359 3.51074 2.94756 3.68314C3.18153 3.85554 3.20615 3.92532 3.45654 4.0813C3.75208 4.26191 4.00658 4.3399 4.34317 4.44252C4.71259 4.55335 5.05739 4.61902 5.4145 4.6888C5.54996 4.71343 5.68952 4.74216 5.82498 4.7709C6.26418 4.8571 6.38322 4.88173 6.53099 4.96792C6.59667 5.00487 6.75265 5.15674 6.72802 5.30451C6.7157 5.3825 6.64182 5.48512 6.39554 5.5508C5.82498 5.69857 5.38167 5.54259 5.04918 5.46049C3.80134 5.15674 3.48938 5.11159 3.3293 5.19369C3.29646 5.2101 3.27183 5.23063 3.27183 5.23063C3.11175 5.35377 3.06659 5.54259 3.04607 5.637C2.95987 6.02284 2.94756 6.30607 2.94756 6.30607C2.94345 6.39637 2.94345 6.39637 2.92293 6.51131C2.90651 6.63034 2.86957 6.96693 2.8162 7.34867C2.77926 7.61959 2.75874 7.75504 2.71769 7.90281C2.68075 8.03417 2.60276 8.27635 2.60276 8.27635C2.60276 8.27635 0.829511 8.92079 0.258952 8.3256C0.0865532 8.14499 0.0619247 7.8905 0.0126679 7.38972C-0.0324842 6.9382 0.0208774 6.59751 0.0455058 6.421C0.324628 4.52461 0.0455058 4.18802 0.484713 3.68725L0.488818 3.68314Z"
          fill="black"
        />
        <path
          d="M1.67893 13.9245H1.32182C1.03038 13.9245 0.79231 13.6864 0.79231 13.395C0.70611 11.9706 0.468035 9.53652 0.381836 8.11217C0.500873 8.03418 0.788205 8.52675 0.94829 8.45287C1.07964 8.38719 1.20689 8.33793 1.32182 8.29689H1.67893C1.79797 8.34204 1.94574 8.16964 2.07709 8.22711C2.23307 8.30099 2.53682 8.03008 2.66818 8.10396C2.57377 9.53241 2.30285 11.9665 2.20844 13.395C2.20844 13.6864 1.97037 13.9245 1.67893 13.9245Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_627_23">
          <rect width="10.7011" height="13.9708" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
